import './style/BaseLayer.css';

const BaseLayer = ({ selectedBaseLayer, setSelectedBaseLayer, map, loadedLayers, handleBaseLayerChange }) => {
  const baseLayersOptions = ["OpenStreetMap", "Faixas de Voo Foto"];

  const handleToggle = (layerName) => {
    const isActive = selectedBaseLayer === layerName;

    if (isActive) {
      handleBaseLayerChange(null, map, loadedLayers, selectedBaseLayer, setSelectedBaseLayer);
    } 
    else {
      handleBaseLayerChange(layerName, map, loadedLayers, selectedBaseLayer, setSelectedBaseLayer);
    }
  };

  return (
    <div className="painel-baselayers">
      <div className="painel-titulo-baselayers">
        Camadas Base
      </div>
      <ul className="painel-lista-radios">
        {baseLayersOptions.map((layerName) => (
          <li key={layerName}>
            <label className="painel-label-base">
              <input
                type="checkbox"
                name="baseLayer"
                className="painel-radiobutton"
                checked={selectedBaseLayer === layerName}
                onChange={() => handleToggle(layerName)}
              />
              {layerName}
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BaseLayer;